import { deleteCookie } from "./cookies";

export const logout = (url: string = "/login") => {
  localStorage.removeItem("lastTime");
  localStorage.removeItem("tutorial");
  deleteCookie("refreshToken");
  window.location.href = url;
};
